<template>
  <div class="box" @click.self.prevent="showState">
    <div class="left" @click="backstate = false">
      <breadcrumb class="breadcrumb-container" />
    </div>
    <div class="right">
      <p>欢迎您 &nbsp; {{adminName}}</p>
      <img src="../../../assets/img/esc.png" alt @click.self.prevent="showToggle" />
      <div class="user_btn" v-if="$store.state.show">
        <el-button type="danger" @click="sureExit" plain>退出登录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import Cookies from "js-cookie";
import { showToggle } from "@/store";
// import { remindOrder } from "@/api/api";
export default {
  data() {
    return {
      // backstate: false,
     adminName: ""
    };
  },
  components: {
    Breadcrumb
  },
  beforeMount() {
    this.adminName = Cookies.get("healthadminName");
  },
  mounted() {
    // this.getNum();
  },
  methods: {
    showToggle() {
      this.$store.dispatch("showToggle");
    },
    showState() {
      this.$store.state.show = false;
    },
    sureExit() {
      let path = this.$route.path;
      localStorage.setItem("power", "");
      this.$router.push({ path: "login?path=" + path });
      this.$store.dispatch("layout");
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box {
  width: calc(100% - 200px);
  height: 60px;
  background: #ffffff;
  position: fixed;
  left: 200px;
  top: 0;
  z-index: 99;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  font-size: 30px;
  display: flex;
  justify-content: space-between;
  .left {
    min-width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .right {
    min-width: 120px;
    max-width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    & > p {
      color: #97a8be;
      cursor: text;
      font-size: 18px;
      margin-right: 30px;
    }
    img {
      width: 20px;
      height: 20px;
      display: block;
      cursor: pointer;
      border-radius: 5px;
      margin-right: 20px;
    }

    .user_btn {
      position: absolute;
      top: 55px;
      right: 40px;
      z-index: 9;
      width: 150px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #d1dbe5;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.12);
      .el-button {
        width: 150px;
        margin: 0 auto;
        background: #fff;
        border: none;
        color: #1b1b1b;
        &:hover {
          background: #d1dbe5;
          color: #3b3b3b;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/top.vue